module.exports = __webpack_public_path__ + "img/DE02305.f67f78cc.png";